<template>
  <div>
    <div class="calendar-box" :class="{ hide: !open }">
      <div class="month-item" :class="[isCurrentMonth(item) ? 'current' : '', chooseIndex == index ? 'choose' : '']" v-for="(item, index) in 12" :key="index" @click="chooseMonth(index)">
        <div class="month" :class="[chooseIndex == index ? 'choose' : '']">{{ item }}月</div>
        <div>1~{{ getLastDay(item) }}</div>
        <div class="point" v-if="showMark(item)" :style="{ backgroundColor: getStatusColor(item) }"></div>
      </div>
    </div>
    <div class="toggle" @click="toggle">
      <img src="https://i.loli.net/2020/07/16/2MmZsucVTlRjSwK.png" class="weektoggle" :class="{ down: open }" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    year: {
      type: String,
      default: new Date().getFullYear().toString(),
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lastDayList: [],
      chooseIndex: '',
      open: true,
    }
  },
  computed: {
    isCurrentMonth() {
      return item => {
        let now = new Date().format('yyyy-MM')
        let date = new Date(this.year, item - 1, 1).format('yyyy-MM')
        if (now == date) {
          return true
        }
        return false
      }
    },
    getLastDay() {
      return month => {
        let date = new Date(this.year, month, 0).getDate()
        // console.log(date)
        return date
      }
    },
    showMark() {
      return item => {
        let date = new Date(this.year, item - 1, 1).format('yyyy-MM')
        // console.log(date)
        // console.log(this.list.findIndex(item => item.ny == date))
        if (this.list.findIndex(item => item.ny == date) != -1) {
          return true
        }
        return false
      }
    },
    getStatusColor() {
      return item => {
        let date = new Date(this.year, item - 1, 1).format('yyyy-MM')
        let index = this.list.findIndex(item => item.ny == date)
        if (index != -1) {
          if (this.list[index].hasData) {
            if (this.list[index].pyzt == '1') {
              return '#41B29C'
            } else if (this.list[index].pyzt == '3') {
              return '#ee0a24'
            } else {
              return '#0189F9'
            }
          }
        }
        return '#FE923F'
      }
    },
  },
  methods: {
    chooseMonth(index) {
      let now = new Date().getTime()
      let clickDate = new Date(this.year, index, 1).getTime()
      if (now >= clickDate) {
        this.chooseIndex = index
        this.$emit('choose', index)
      }
    },
    toggle() {
      this.open = !this.open
    },
  },
  created() {},
}
</script>

<style lang="less" scoped>
.calendar-box {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  overflow: hidden;
  transition: all 0.8s;
}
.month-item {
  position: relative;
  width: 49px;
  height: 50px;
  background: #f2f2f4;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 10px;
  color: #999999;
  text-align: center;
  .month {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    text-align: center;
  }
  .point {
    position: absolute;
    width: 4px;
    height: 4px;
    background: #0189f9;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    bottom: 2px;
  }
}
.current {
  background: #deeefd;
}
.choose {
  background: #0189f9;
  color: #fff !important;
}
.toggle {
  text-align: center;
  line-height: 30px;
  height: 30px;

  .weektoggle {
    width: 42px;
    height: 16px;
    position: relative;
    bottom: -18px;

    &.down {
      transform: rotate(180deg);
      bottom: -6px;
    }
  }
}
.hide {
  height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/calendarMonth.vue